import type { Lesson } from '../schema.js';

export const DEFENSE_LESSONS: Lesson[] = [
  {
    id: 'defend-out-of-check',
    slug: 'defense-respond-to-check',
    title: 'Respond to a check',
    audienceLevel: 'beginner',
    concepts: ['defense'],
    steps: [
      {
        kind: 'explain',
        title: 'Your king is in danger',
        body: 'When your king is in check you MUST answer it. The three ways are: capture the checking piece, block the check, or move the king away.',
        narration: 'A check must be answered right away.',
      },
      {
        kind: 'drill',
        task: 'best-move',
        title: 'Capture the attacker',
        body: 'Your king is in check from the black queen. A piece can capture it. Make the best move!',
        fen: '4k3/8/8/8/8/8/4q3/3K2N1 w - - 0 1',
        answer: ['Nxe2', 'Kxe2'],
        solution: ['Nxe2'],
        expect: 'win-material',
        hint: 'A knight can capture the queen.',
        hintLadder: ['A knight can capture the queen.', 'Check which of your pieces attacks e2.', 'Nxe2 captures the queen!'],
      },
      {
        kind: 'quiz',
        title: 'Defense check',
        body: 'A quick check on defense.',
        questions: [
          { prompt: 'When your king is in check, you must:', choices: ['Respond to the check', 'Make a plan on the other side'], correct: 0 },
          { prompt: 'Which is a way to answer a check?', choices: ['Capture the checking piece', 'Move your queen far away'], correct: 0 },
        ],
      },
    ],
  },
];
